import React, { useContext, useEffect } from 'react';
import {Helmet} from 'react-helmet';
import _ from 'lodash';

import '../sass/main.scss';

import { ThemeContext } from "../context/ThemeProvider"
import { VscColorMode } from 'react-icons/vsc';

// GET SITE TITLE - {_.get(this.props, 'pageContext.site.siteMetadata.title', null)}

export default function Body(props) {

    const [mode, setMode] = useContext(ThemeContext)

    useEffect(() => {
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
            setMode(true)
        }
    }, [])

    return (
        <React.Fragment>
            <Helmet>
                <title>{_.get(props, 'pageContext.frontmatter.title', null) && (_.get(props, 'pageContext.frontmatter.title', null))}</title>
                <meta charSet="utf-8"/>
                <meta name="viewport" content="width=device-width, initialScale=1.0" />
                <meta name="description" content={_.get(props, 'pageContext.frontmatter.excerpt', null) || _.get(props, 'pageContext.site.siteMetadata.description', null)}/>
                <link href="https://fonts.googleapis.com/css?family=PT+Serif:400,400i,700,700i&display=swap" rel="stylesheet"/>
                {(_.get(props, 'pageContext.frontmatter.template', null) === 'post') && (
                _.get(props, 'pageContext.frontmatter.canonical_url', null) && (
                <link rel="canonical" href={_.get(props, 'pageContext.frontmatter.canonical_url', null)}/>
                )
                )}
            </Helmet>
            <div style={{
                backgroundColor: mode ? "#131415" : "#fff",
                color: mode ? "#fff" : "#000000"
            }} id="page" className={'site palette-' + _.get(props, 'pageContext.site.siteMetadata.palette', null)}>
                {props.children}
            </div>
            <div style={{
                top: 'auto',
                right: 30,
                bottom: 20,
                left: 'auto',
                position: 'fixed',
                color: mode ? "#fff" : "#000"
            }}>
                <VscColorMode onClick={() => {
                    if(mode === false) {
                        setMode(true)
                    } else {
                        setMode(false)
                    }
                }} fontSize="30" />
            </div>
        </React.Fragment>
    )
}
